import React from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { multiPricesForm } from '../../utils/validations';


const MultiPriceForm = ({ multiInputs, setShowMultiPriceForm, settings, multiPriceList, setFieldValue, colorLinking, sellEvenOutOfStock }) => {
    return (
        <>
            <Formik
                initialValues={multiInputs}
                validationSchema={multiPricesForm}
                onSubmit={async (values, { setSubmitting }) => {
                    if (multiInputs.id >= 0) { // Check if id exists and is valid index
                        let list = [...multiPriceList];
                        list[multiInputs.id] = { ...values }; // Create new object to avoid reference issues
                        setFieldValue("multiPriceList", list);
                    } else {
                        let list = [...(multiPriceList || []), { ...values }]; // Handle null multiPriceList
                        setFieldValue("multiPriceList", list);
                    }
                    setShowMultiPriceForm(false)
                }}
            >
                {({ values, errors, setFieldValue, submitForm }) => (
                    <Form>
                        <div className='border p-2'>
                            <div className='flex-grow-1'>
                                <label htmlFor="">Option title</label>
                                <Field name="title" type="text"
                                    className='form-control' />
                                <ErrorMessage name='title' component="small" className="text-danger" />
                            </div>
                            <div className='flex-grow-1'>
                                <label htmlFor="">Option Description</label>
                                <textarea
                                    name="description"
                                    value={values.description}
                                    onChange={(event) => setFieldValue("description", event.target.value)}
                                    className='form-control'></textarea>
                                <ErrorMessage name='description' component="small" className="text-danger" />
                            </div>
                            <div className="d-flex justify-content-between gap-2 mt-2">
                                <div className='flex-grow-1 mb-3'>
                                    <label htmlFor="">Selling Price</label>
                                    <div className="input-group   ">
                                        <span className="input-group-text rounded-0">{settings?.currencySymbol}</span>
                                        <Field name="sellPrice" type="number" className="form-control" placeholder="Amount" />
                                    </div>
                                    <ErrorMessage name='sellPrice' component="small" className="text-danger" />
                                </div>
                                <div className='flex-grow-1 mb-3'>
                                    <label htmlFor="">Regular Price</label>
                                    <div className="input-group">
                                        <span className="input-group-text rounded-0"  >{settings?.currencySymbol}</span>
                                        <Field name="oldPrice" type="number" className="form-control" placeholder="Amount" />
                                    </div>
                                    <ErrorMessage name='oldPrice' component="small" className="text-danger" />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between gap-2">
                                <div className='w-50'>
                                    <label htmlFor="">Cost per unit</label>
                                    <div className="input-group mb-3 " >
                                        <span className="input-group-text rounded-0"  >{settings?.currencySymbol}</span>
                                        <Field name="cost" type="number" className="form-control" placeholder="Amount" />
                                        <ErrorMessage name='cost' component="small" className="text-danger" />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-around  w-50">
                                    <div>
                                        <label htmlFor="">Profit/Loss</label>
                                        <div className={`${values.sellPrice - values.cost > 0 ? "text-success" : "text-danger"}`}> {settings?.currencySymbol} {values.sellPrice - values.cost}</div>
                                    </div>
                                    <div>
                                        <label htmlFor="">Profit Margin</label>
                                        <div className={`${values.sellPrice > 0 && values.cost > 0 ? ((values.sellPrice - values.cost) / values.sellPrice * 100).toFixed(2) > 0 ? "text-success" : "text-danger" : "text-muted"}`}>
                                            {values.sellPrice > 0 && values.cost > 0 ? ((values.sellPrice - values.cost) / values.sellPrice * 100).toFixed(2) : 0}%
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between gap-2">
                                <div className='flex-grow-1'>
                                    <label htmlFor="">Available Quantity</label>
                                    <Field name="stockInHand" disabled={sellEvenOutOfStock} type="number" className='form-control' />
                                    <ErrorMessage name='stockInHand' component="small" className="text-danger" />
                                </div>
                                <div className='flex-grow-1'>
                                    <label htmlFor="">Barcode (SKU/UPC)</label>
                                    <Field name="barCode" type="text" className='form-control' />
                                </div>
                            </div>
                            {colorLinking && (
                                <div className="d-flex justify-content-between gap-2 mt-1">
                                    <div className='flex-grow-1'>
                                        <label htmlFor="">Color/Stock in hand</label>
                                        {values.colors.map((data, index) => {
                                            return (
                                                <div className='d-flex align-items-center gap-3' >
                                                    <div className={"multiPriceColorBox"} style={{ backgroundColor: data.color }}>
                                                    </div>
                                                    <div className='flex-grow-1'>
                                                        <Field
                                                            name={`colors.${index}.color`}
                                                            type="hidden" className='form-control' />
                                                        <Field
                                                            disabled={sellEvenOutOfStock}
                                                            name={`colors.${index}.stockInHand`}
                                                            type="text" className='form-control' />
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}
                            <div className="d-flex justify-content-end mt-2">
                                <button type="button" className="colorSaveBtn px-3 py-1 rounded me-2"
                                    onClick={() => setShowMultiPriceForm(false)}
                                >Cancel</button>
                                <button type="button" className="colorSaveBtn px-3 py-1 rounded"
                                    onClick={() => submitForm()}
                                >{values?.id ? "Update" : "Add"}</button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik >

        </>
    )
}

export default MultiPriceForm